import React from "react";
import styled from "styled-components";

interface CardProps {
  title: string;
  children?: React.ReactNode;
}

const Card: React.FC<CardProps> = ({ title, children }) => {
  return (
    <CardWrapper>
      <Title>{title}</Title>
      {children}
    </CardWrapper>
  );
};

const CardWrapper = styled.div`
  margin: 10px;
  padding: 10px 15px;
  width: calc(100vw - 50px);
  height: 150px;
  border-radius: 15px;
  overflow: hidden;
  background-color: ${({ theme }) => theme.backgroundColor};
`;

const Title = styled.h2`
  color: ${({ theme }) => theme.buttonTextColor};
`;

export default Card;
